import { dateFormat } from 'src/helpers/date_helper';

type FormatFn = (id: string, options: { values?: Record<string, string>; default?: string }) => string;

export function localizedLastUpdate(
	timestampMs: number | null | undefined,
	locale: string | null | undefined,
	formatKey: string,
	formatFn: FormatFn,
): string {
	if (!locale || timestampMs == null) {
		return '';
	}

	const date = dateFormat(timestampMs, 'd M, Y');

	return formatFn(formatKey, {
		values: { date },
		default: `Last update ${date}.`,
	});
}
